import React, { useRef } from 'react'
import SignatureCanvas from 'react-signature-canvas'

export default function Signing({amount, tip, loading, onComplete, onBack}) {
  const canvas = useRef()

  const onDone = () => {
    const data = canvas.current.getTrimmedCanvas().toDataURL('image/png')
    onComplete(data)
  }

  return <div className={'tip-content' + (loading ? ' isLoading' : '')}>
    <div className='tip-header'>
      <div className='amount'>{`$${(parseFloat(amount) + parseFloat(tip || '0')).toFixed(2)}`}</div>
    </div>

    <div className='tip-signing'>
      <SignatureCanvas ref={canvas} />
      <div className='agreement'>I agree to pay the above amount for the service rendered</div>
    </div>

    <div className='signing-buttons'>
      <div className='tip-button signing-button' onClick={onBack}>Back</div>
      <div className='tip-button signing-button' onClick={() => canvas.current.clear()}>Clear</div>
      <div className='tip-button signing-button done' onClick={onDone}>Done</div>
    </div>
  </div>
}
